import { render, staticRenderFns } from "./ReceteDurumCellRenderer.vue?vue&type=template&id=25afc447"
import script from "./ReceteDurumCellRenderer.vue?vue&type=script&lang=js"
export * from "./ReceteDurumCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./ReceteDurumCellRenderer.vue?vue&type=style&index=0&id=25afc447&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports